var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { SettingType } from '../../../../../common/api';
import { useLanguage } from '../../base/LanguageProvider';
import { useSetting } from '../../data/hooks/settings';
import { useActiveYears } from '../../data/hooks/timePoints';
import { TemplatedGrid } from '../../styled/Grid';
import SelectInput from './SelectInput';
function IntervalSelect(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var L = useLanguage().L;
    var activeYears = useActiveYears();
    var financialYearStartingMonth = useSetting(SettingType.FinancialYearStartingMonth);
    var start = props.start;
    var end = props.end;
    var type = (_a = props.type) !== null && _a !== void 0 ? _a : 'months';
    var isMonths = type === 'months';
    var colTemplate = isMonths ? '2fr 2fr' : 'auto';
    var year = new Date().getFullYear();
    var monthFrom = start && isMonths ? start.getMonth() + 1 : 1;
    var monthTo = end && isMonths ? end.getMonth() + 1 : 12;
    var yearFrom = start ? start.getFullYear() : year;
    var yearTo = end ? end.getFullYear() : year;
    var years = (_b = activeYears === null || activeYears === void 0 ? void 0 : activeYears.map(function (y) {
        return {
            label: '' + y,
            value: Number(y),
        };
    })) !== null && _b !== void 0 ? _b : [];
    var offset = +((_c = financialYearStartingMonth === null || financialYearStartingMonth === void 0 ? void 0 : financialYearStartingMonth.value) !== null && _c !== void 0 ? _c : 1) - 1;
    var months = [];
    for (var i = 1; i <= 12; i++) {
        months.push({
            label: '' + (i + offset > 12 ? i + offset - 12 : i + offset),
            value: i,
        });
    }
    var fromYears = __spreadArray([], __read(years), false);
    var toYears = __spreadArray([], __read(years), false);
    if ((_d = props.none) === null || _d === void 0 ? void 0 : _d.from) {
        fromYears.unshift({ label: props.none.from, value: null });
    }
    if ((_e = props.none) === null || _e === void 0 ? void 0 : _e.to) {
        toYears.unshift({ label: props.none.to, value: null });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TemplatedGrid, { style: { width: isMonths ? 'auto' : '100%' }, "$colTemplate": colTemplate },
            React.createElement(SelectInput, { size: props.size, name: "yearFrom", options: fromYears, value: start === null && ((_f = props.none) === null || _f === void 0 ? void 0 : _f.from) ? start : yearFrom, label: L('Start year'), onChange: function (e) {
                    var _a;
                    var selected = Number(e.target.value);
                    if (!monthFrom) {
                        return;
                    }
                    (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, {
                        name: 'start',
                        value: new Date(selected, monthFrom - 1),
                    });
                }, bottomMargin: true }),
            isMonths && (React.createElement(SelectInput, { size: props.size, name: "monthFrom", options: months, value: monthFrom, label: L('Start month'), onChange: function (e) {
                    var _a;
                    var selected = Number(e.target.value);
                    if (!yearFrom) {
                        return;
                    }
                    (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, {
                        name: 'start',
                        value: new Date(yearFrom, selected - 1),
                    });
                }, bottomMargin: true }))),
        React.createElement(TemplatedGrid, { style: { width: isMonths ? 'auto' : '100%' }, "$colTemplate": colTemplate },
            React.createElement(SelectInput, { size: props.size, name: "yearTo", label: L('End year'), options: toYears, value: end === null && ((_g = props.none) === null || _g === void 0 ? void 0 : _g.to) ? end : yearTo, onChange: function (e) {
                    var _a;
                    var selected = Number(e.target.value);
                    if (!monthTo) {
                        return;
                    }
                    (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, {
                        name: 'end',
                        value: new Date(selected, monthTo - 1),
                    });
                }, bottomMargin: true }),
            isMonths && (React.createElement(SelectInput, { size: props.size, name: "monthTo", label: L('End month'), options: months, value: monthTo, onChange: function (e) {
                    var _a;
                    var selected = Number(e.target.value);
                    if (!yearTo) {
                        return;
                    }
                    (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, {
                        name: 'end',
                        value: new Date(yearTo, selected - 1),
                    });
                }, bottomMargin: true })))));
}
export default IntervalSelect;
